/**
 * Scrollable body wrapper for details views (modal or inline).
 */

import * as React from 'react';
import { cn } from '@/lib/utils';

/** Props for {@link DetailsViewContent}. */
interface DetailsViewContentProps {
  children?: React.ReactNode;
  className?: string;
}

/** Content wrapper for an entity details view. */
export const DetailsViewContent: React.FC<DetailsViewContentProps> = ({ children, className }) => {
  if (!children) return null;
  return <div className={cn('details-view-content', className)}>{children}</div>;
};
